module.exports = __webpack_public_path__ + "bcd62d7ea0b124baa0cdd16f57050299.woff";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/Lato-Bold.woff
// module id = 717
// module chunks = 0